import { render, staticRenderFns } from "./sortArrow.vue?vue&type=template&id=47fd5fcb"
import script from "./sortArrow.vue?vue&type=script&lang=ts"
export * from "./sortArrow.vue?vue&type=script&lang=ts"
import style0 from "./sortArrow.vue?vue&type=style&index=0&id=47fd5fcb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports